import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import Breadcrumb from './breadcrumb.vue';
import pageTitle from '@/router/lang/page-title';
let default_1 = class default_1 extends Vue {
    currPage = '';
    mounted() {
        const nav = this.$route;
        this.currPage = nav.meta && nav.meta.page ? nav.meta.page : '';
    }
    onRouteChange(route) {
        const nav = route;
        this.currPage = nav.meta && nav.meta.page ? nav.meta.page : '';
    }
};
__decorate([
    Watch('$route')
], default_1.prototype, "onRouteChange", null);
default_1 = __decorate([
    Component({
        name: 'NavMain',
        components: {
            Breadcrumb,
        },
        i18n: {
            sharedMessages: pageTitle
        },
    })
], default_1);
export default default_1;
